//import { Notification } from "element-ui";
import { api } from "../../gateways/unilabApi";

export default {
  getUms(category) {
    return new Promise((resolve, reject) => {
      api
        .get(`um/categories/${category}`)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          //Notification.error({
          //  title: "Attenzione",
          //  message: error.data.errorMessage
          //});
          reject(error);
        });
    });
  },
  getUmsDictionary() {
    return new Promise((resolve, reject) => {
      api
        .get(`um/dictionaty`)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          //Notification.error({
          //  title: "Attenzione",
          //  message: error.data.errorMessage
          //});
          reject(error);
        });
    });
  },
  getUmConvInfo(from, to) {
    /* from = encodeURI(from).replace("/", "%2F");
    to = encodeURI(to).replace("/", "%2F");
    /${from}/${to} */
    return new Promise((resolve, reject) => {
      api
        .post(`um/umconvinfo`, { from: from, to: to })
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          //Notification.error({
          //  title: "Attenzione",
          //  message: error.data.errorMessage
          //});
          reject(error);
        });
    });
  }
};
